// src/polyfills.js is NOT imported here. It is listed in angular.json `scripts` for both the build
// and test targets, so importing it as well bundled it twice -- and the test target has no
// main.ts, which means the `scripts` entry is the only thing that loads it under Karma.
//
// The matching Array<T>.cast<U>() type declaration lives in src/global.d.ts so the spec
// compilation can see it too -- see the comment there.
import {bootstrapApplication} from '@angular/platform-browser';
import {AppComponent} from './app/app.component';
import {getAppConfig} from "./app/app.config";


(async () => {
  try {
    const userAgent = navigator.userAgent;
    const r7Index = userAgent.indexOf('RP7-');
    if (r7Index !== -1) {
      // don't check for the known guid, just check if it matches the format
      const r7Str = userAgent.slice(r7Index + 4, r7Index + 36 + 4); // 4 = length of RP7-
      if (/^[0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}$/i.test(r7Str)) {
        return;
      }
    }
  } catch {
    // ignore
  }

  bootstrapApplication(AppComponent, await getAppConfig())
    .catch((err) => console.error(err));
})();
